<template>
  <div>
    <div
      class="text-break text-center"
      style="white-space: pre-wrap; line-height: 1.3"
      :style="{'font-size': `${fontSize}px`}"
      v-html="text"
    />
  </div>
</template>

<script>
export default {
  name: 'CustomText',
  props: {
    text: {
      type: String,
      required: true,
    },
    fontSize: {
      type: Number,
      required: true,
    },
  },
};
</script>
